module.exports = __webpack_public_path__ + "img/2.3ebfb17e.jpg";